import { Link } from "@simplybusiness/mobius";
import { TrustBanner } from "../TrustBanner/TrustBanner";
import { TrustBannerImages } from "../TrustBanner/TrustBannerImages";
import { usePreload } from "../../hooks";
import type { InterventionProps } from "../../types";

const TRUSTPILOT_REVIEW_URL =
  "https://uk.trustpilot.com/review/simplybusiness.co.uk";

export const ClickableTrustpilotBanner = (props: InterventionProps) => {
  usePreload(TrustBannerImages["trustpilot_alternate"].src);

  if (!props.data || !props.data.show || !props.fireEvent) return null; // show=false and missing fireEvent shouldn't happen but just in case

  const handleClick = () => {
    props.fireEvent?.("clicked_embedded_trust_banner");
  };

  return (
    <Link
      href={TRUSTPILOT_REVIEW_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="View Simply Business reviews on Trustpilot in a new tab"
      onClick={handleClick}
    >
      <TrustBanner variant="trustpilot_alternate" />
    </Link>
  );
};
